// eslint-disable-next-line import/prefer-default-export
export const snackbarColor = state => state.color;
export const snackbarActive = state => state.active;
export const snackbarMessage = state => state.message;
